import { loadStripe } from "@stripe/stripe-js";

const STRIPE_TEST_KEY =
  "pk_test_51IUy5xJRxV5R2NYDjHqpjfGQwnwmYVW6gHZ846jOAMJenug40yUSSA2s60GJivyX2NWQCSjPUhXF5enHSsOadpOz00jaZLNzPL";
const STRIPE_LIVE_KEY =
  "pk_live_51IUy5xJRxV5R2NYDlujFWqdAd9h1lOnH27I7W7KsgZt6ehvnpnJ9kzY6Q3yINghCbWwCg6qZnDEKAUQnMN9CG11w00jFQA7Txe";

export const stripeTestInstance = loadStripe(STRIPE_TEST_KEY);
export const stripeLiveInstance = loadStripe(STRIPE_LIVE_KEY);
